import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageLinesOpen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#CFD8DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.25 12.5C19.6562 12.5 20 12.8438 20 13.25C20 13.6875 19.6562 14 19.25 14H12.75C12.3125 14 12 13.6875 12 13.25C12 12.8438 12.3125 12.5 12.75 12.5H19.25ZM16.25 15.5C16.6562 15.5 17 15.8438 17 16.25C17 16.6875 16.6562 17 16.25 17H12.75C12.3125 17 12 16.6875 12 16.25C12 15.8438 12.3125 15.5 12.75 15.5H16.25ZM22 8C23.0938 8 24 8.90625 24 10V19.0312C24 20.125 23.0938 21.0312 22 21.0312H17.5L13.5938 23.9375C13.3438 24.125 13 23.9375 13 23.6562V21.0312H10C8.875 21.0312 8 20.125 8 19.0312V10C8 8.90625 8.875 8 10 8H22ZM22.5 19.0312V10C22.5 9.75 22.25 9.5 22 9.5H10C9.71875 9.5 9.5 9.75 9.5 10V19.0312C9.5 19.2812 9.71875 19.5312 10 19.5312H14.5V21.4062L17 19.5312H22C22.25 19.5312 22.5 19.2812 22.5 19.0312Z",
			fill: "#607D8B"
		})
	]
});
const ForwardRef = forwardRef(SvgMessageLinesOpen);
export { ForwardRef as ReactComponent };
